export default __webpack_public_path__ + "static/media/trade.cc5bb17a.JPG";